// Restored from the pre-Vite-migration implementation (git history), keeping
// the current key *values* already in live use (personaId/chatId/projectId)
// and adding the params useChatController.ts/lib.tsx/useChatSessionController.ts
// actually need (SEARCH_ID, USER_PROMPT, SUBMIT_ON_LOAD, TITLE, SEEDED,
// SKIP_RELOAD, MODEL_VERSION). See BUG-UI-V3-009.
export const SEARCH_PARAM_NAMES = {
  PERSONA_ID: "personaId",
  CHAT_ID: "chatId",
  SEARCH_ID: "searchId",
  PROJECT_ID: "projectId",
  QUERY: "query",
  SEARCH_TYPE: "searchType",
  ALL_MY_DOCUMENTS: "allMyDocuments",
  // overrides
  TEMPERATURE: "temperature",
  MODEL_VERSION: "model-version",
  SYSTEM_PROMPT: "system-prompt",
  STRUCTURED_MODEL: "structured-model",
  // user message
  USER_PROMPT: "user-prompt",
  SUBMIT_ON_LOAD: "submit-on-load",
  // chat title
  TITLE: "title",
  FILES: "files",
  // for seeding chats
  SEEDED: "seeded",
  SEND_ON_LOAD: "send-on-load",
  // when sending a message for the first time, we don't want to reload the
  // page and cause a re-render
  SKIP_RELOAD: "skip-reload",
} as const;

export function shouldSubmitOnLoad(searchParams: URLSearchParams | null) {
  const rawSubmitOnLoad = searchParams?.get(SEARCH_PARAM_NAMES.SUBMIT_ON_LOAD);
  return rawSubmitOnLoad === "true" || rawSubmitOnLoad === "1";
}
